const wecomBinding = {
  title: 'Link WeCom account',
  subtitle: 'Sign in with WeCom to link your account',
  subtitleWithApp: 'Complete verification to continue using “{{app}}”',
  processing: 'Checking the binding result…',
  auth: {
    action: 'Sign in with WeCom',
    description:
      'Continue in WeCom using the shared passwordless sign-in flow. On first use, follow the prompts to authorize your enterprise email or link your account.',
  },
  success: {
    title: 'Binding successful. You can continue the conversation.',
    description: 'Return to WeCom and send your next message.',
  },
  expired: { title: 'Binding link expired', description: 'Return to WeCom and start again.' },
  conflict: {
    title: 'WeCom identity does not match',
    description:
      'Open the link with the WeCom account that started the conversation. Contact an administrator if the problem persists.',
  },
  channelClosed: {
    title: 'IM conversations are disabled',
    description:
      'An administrator has disabled IM conversations for this application. Contact the application administrator.',
  },
  error: {
    title: 'Unable to complete binding',
    description: 'Retry or return to WeCom and start again.',
    retry: 'Retry',
  },
}
export default wecomBinding
